//@flow

import { getCookie } from "react-simple-cookie-store"
import { LOCALE_COOKIE, LOCALE_EN } from "./constants"

export default (): string => getCookie(LOCALE_COOKIE) || LOCALE_EN



// WEBPACK FOOTER //
// ./src/Intl/getLocaleFromCookie.js